/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Failedtoloadbusinesses3Inputs */

const en_failedtoloadbusinesses3 = /** @type {(inputs: Failedtoloadbusinesses3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to load businesses`)
};

const de_failedtoloadbusinesses3 = /** @type {(inputs: Failedtoloadbusinesses3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmen konnten nicht geladen werden`)
};

/**
* | output |
* | --- |
* | "Failed to load businesses" |
*
* @param {Failedtoloadbusinesses3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const failedtoloadbusinesses3 = /** @type {((inputs?: Failedtoloadbusinesses3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Failedtoloadbusinesses3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_failedtoloadbusinesses3(inputs)
	return de_failedtoloadbusinesses3(inputs)
});
export { failedtoloadbusinesses3 as "failedToLoadBusinesses" }